import { bindActionCreators, createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

type ShareStateType = {
  loading: boolean
}

const initialState = {
  loading: false
}

const shareSlice = createSlice({
  name: 'share',
  initialState,
  reducers: {
    setLoading: (state: Draft<ShareStateType>, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  }
})

const shareReducer = shareSlice.reducer

export const shareActions = shareSlice.actions

export const useShareActions = () => {
  const dispatch = useDispatch()
  return useMemo(() => bindActionCreators(shareActions, dispatch), [dispatch])
}

export default shareReducer
